<template>
  <header
    class="site-header"
    :class="{ 'is-solid': solid || open }"
    @keydown.esc="closeMenu"
  >
    <div class="shell nav-row">
      <a
        href="#top"
        class="brand-link"
        aria-label="West Dev Solutions home"
        @click="open = false"
      >
        <!-- Symbol at the kit's 64px minimum, beside the compact wordmark.
             Reverse artwork over the dark hero, primary on the white bar. -->
        <span class="brand-lockup logo-on-dark">
          <img class="brand-symbol" src="/brand/symbol-reverse.svg" width="64" height="36" alt="" />
          <img class="brand-word" src="/brand/wordmark-compact-cream.svg" width="145" height="17" alt="West Dev Solutions" />
        </span>
        <span class="brand-lockup logo-on-light" aria-hidden="true">
          <img class="brand-symbol" src="/brand/symbol-primary.svg" width="64" height="36" alt="" />
          <img class="brand-word" src="/brand/wordmark-compact-ink.svg" width="145" height="17" alt="" />
        </span>
      </a>
      <nav class="desktop-nav" aria-label="Primary">
        <a
          v-for="link in links"
          :key="link.href"
          :href="link.href"
          :class="{ 'is-active': active === link.href }"
          :aria-current="active === link.href ? 'true' : null"
          >{{ link.label }}</a
        >
        <a href="#contact" class="btn btn-primary">Start a project</a>
      </nav>
      <button
        ref="toggle"
        class="menu-toggle"
        :aria-expanded="open"
        aria-controls="mobile-menu"
        @click="open = !open"
      >
        {{ open ? "Close" : "Menu" }}
      </button>
    </div>
    <nav
      v-show="open"
      id="mobile-menu"
      class="mobile-nav shell"
      aria-label="Mobile"
    >
      <a
        v-for="link in links"
        :key="link.href"
        :href="link.href"
        @click="open = false"
        >{{ link.label }}</a
      >
      <a href="#contact" class="btn btn-primary" @click="open = false"
        >Start a project</a
      >
    </nav>
  </header>
</template>
<script>
export default {
  name: "NavbarElement",
  data: () => ({
    open: false,
    solid: false,
    active: null,
    links: [
      { href: "#services", label: "Services" },
      { href: "#work", label: "Work" },
      { href: "#process", label: "Process" },
      { href: "#about", label: "About" },
      { href: "/connect", label: "Connect" },
    ],
  }),
  mounted() {
    this.onScroll();
    window.addEventListener("scroll", this.onScroll, { passive: true });
    // The page sections render after the router resolves, so wait for them
    this.$router.isReady().then(() => this.$nextTick(this.watchSections));
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
    if (this.observer) this.observer.disconnect();
  },
  methods: {
    // Transparent over the hero photo, solid once the page scrolls
    onScroll() {
      this.solid = window.scrollY > 24;
    },
    // Highlight the nav link for the section in the middle of the viewport
    watchSections() {
      if (!("IntersectionObserver" in window)) return;
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.active = `#${entry.target.id}`;
            else if (this.active === `#${entry.target.id}`) this.active = null;
          });
        },
        { rootMargin: "-45% 0px -50% 0px" }
      );
      this.links.forEach(({ href }) => {
        const section = href.startsWith("#") ? document.querySelector(href) : null;
        if (section) this.observer.observe(section);
      });
    },
    closeMenu() {
      this.open = false;
      this.$refs.toggle.focus();
    },
  },
};
</script>
